import { WorkflowListItem, WorkflowsParsedData } from '../workflows.types';

export const parseTableData = (items: WorkflowListItem[]): WorkflowsParsedData[] =>
  items.map((item) => ({
    workflowName: item.name,
    isArchived: item.isArchived,
    actions: { workflowId: item.id },
  }));
